export default "__VITE_ASSET__CRpgt2Mr__"